import React, { useState } from 'react';
import T from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import MonthsDropdown from '../../../../_shared/components/MonthsDropdown';
import TransitionsChart from '../../../../_shared/components/TransitionsChart';
import TransitionsTable from '../../../../_shared/components/TransitionsTable';
import Button from '../../../../../../components/Buttons/Button';
import CollapsibleSlot from '../../../../../../components/CollapsibleSlot';
import ErrorStateWithReload from '../../../../../../components/ErrorStateWithReload';
import useTransitionsTableAxes from '../../../hooks/useTransitionsTableAxes';
import { aiCohortsNodes, aiCohortsChurnedNames } from '../../../configs/constants';
import { lastTransitionDate } from '../../../utils';
import { usageTransitionsSelector } from '../../../selectors';
import { fetchUsageTransitions } from '../../../actions';

const UsageTransitions = ({ isPress }) => {
  const dispatch = useDispatch();

  const { settings, data, filters } = useSelector(usageTransitionsSelector);

  const { tableData, columns, rows } = useTransitionsTableAxes({ data: data.table_data });

  const [isOpen, setOpen] = useState(false);

  const handlePeriodChange = (value) => {
    dispatch(fetchUsageTransitions({ month_date: value }));
  };

  if (settings.error) return <ErrorStateWithReload className="py-xl" />;

  return (
    <div className="usage-transitions">
      <header className="section-body-header">
        <div className="section-body-header__left">
          <h4 className="section-body-header__title">Usage Frequency Transitions</h4>
          <p className="section-body-header__description">
            Visualizes how users move between AI usage segments across periods.
          </p>
        </div>
        <div className="section-body-header__right">
          <MonthsDropdown
            selected={filters.month_date}
            latestMonth={lastTransitionDate}
            disabled={settings.pending}
            onChange={handlePeriodChange}
          />
          <div className="separator-v" />
          <Button
            shape="square"
            variant="secondary"
            active={isOpen}
            onClick={() => setOpen((open) => !open)}
          >
            <span className="hicon-list-button" />
          </Button>
        </div>
      </header>
      <TransitionsChart
        settings={settings}
        data={data}
        nodes={aiCohortsNodes}
        exitNodeNames={aiCohortsChurnedNames}
        selectedDate={filters.month_date}
        isPress={isPress}
      />
      <CollapsibleSlot show={isOpen} className="toggle-collapsible--slide-in-out">
        <TransitionsTable
          data={tableData}
          rows={rows}
          columns={columns}
          isPending={settings.pending}
        />
      </CollapsibleSlot>
    </div>
  );
};

UsageTransitions.propTypes = {
  isPress: T.bool,
};
export default UsageTransitions;
